import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { SvgIconComponent } from './../@theme/components/svg-icon/svg-icon.component';
//import { BottomBarComponent } from './@theme/bottom-bar/bottom-bar.component';
import { ShareBottomsheetComponent } from './../@theme/components/share-bottomsheet/share-bottomsheet.component';
import { DialogComponent } from './../@theme/components/dialog/dialog.component';
import { SanitizeHtmlPipe } from './../@core/pipes/sanitize-html.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [
    SvgIconComponent,
	  ShareBottomsheetComponent,
	  DialogComponent,
	  SanitizeHtmlPipe
  ],
  imports: [
    CommonModule,
    MatListModule,
    MatButtonModule,
    RouterModule,
    MatDialogModule
  ],
  exports: [
    SvgIconComponent,
	ShareBottomsheetComponent,
	DialogComponent, 
	SanitizeHtmlPipe
  ]
})
export class SharedModule { }
